// src/common/hooks/useLogout.ts
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getApi } from "../../api/api";
import { removeFromStorage } from "../../common/utils/functions/localStorage";
import { setAuthToken } from "../../store/slices/authSlice";
import { resetCurrentUser } from "../../store/slices/currentUserSlice";
import { ROUTES } from "../utils/constants";

export const useLogout = () => {
  const api = getApi();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logOut = useCallback(async () => {
    if (isLoggingOut) return;

    setIsLoggingOut(true);

    try {
      // 1. Пытаемся logout на сервере
      try {
        await api.logout();
      } catch (apiError) {
        console.warn(
          "Server logout failed, continuing with local cleanup:",
          apiError,
        );
      }

      // 2. Очищаем localStorage
      const storageKeys = ["accessToken", "refresh", "currentUser"];
      storageKeys.forEach((key) => removeFromStorage(key));

      // 3. Очищаем Redux store
      dispatch(setAuthToken(""));
      dispatch(resetCurrentUser());

      // 4. Редирект на главную
      navigate(ROUTES.MAIN, { replace: true });
    } catch (error) {
      // Даже при ошибке пытаемся очистить состояние
      try {
        dispatch(setAuthToken(""));
        dispatch(resetCurrentUser());
        navigate(ROUTES.MAIN, { replace: true });
      } catch (navError) {}
    } finally {
      setIsLoggingOut(false);
    }
  }, [api, dispatch, navigate, isLoggingOut]);

  return {
    logOut,
    isLoggingOut,
  };
};
